import { API_ENDPOINTS } from "../../ApiService";

export const TOKEN_KEY = "fitnesscoachingapp";

export const storeToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const storeUserData = (data) => {
  if (!data || !data.token) {
    console.error("❌ ERROR: No token in response!", data);
    return;
  }

  // Use data.roles if available; otherwise, fall back to data.role
  const role =
    data.roles && data.roles.length > 0
      ? data.roles[0]
      : data.role || "ROLE_USER";

  const userData = {
    token: data.token,
    refreshToken: data.refreshToken,
    hasCompletedForm:
      data.hasCompletedForm !== undefined ? data.hasCompletedForm : false,
    role,
    id: data.id || null,
  };

  localStorage.setItem(TOKEN_KEY, JSON.stringify(userData));
  console.log("✅ Processed user data stored:", userData);
  return userData;
};

export const getUserData = () => {
  const storedData = localStorage.getItem(TOKEN_KEY);
  if (!storedData) {
    console.warn("⚠️ No user data found in localStorage");
    return null;
  }
  try {
    return JSON.parse(storedData);
  } catch (error) {
    console.error("🚨 Error parsing user data from storage:", error);
    localStorage.removeItem(TOKEN_KEY);
    return null;
  }
};

export const removeUserData = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const login = async (username, password) => {
  const response = await fetch(API_ENDPOINTS.LOGIN, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  });

  if (response.ok) {
    const data = await response.json();
    storeUserData(data);
    return true;
  }

  return false;
};

export const isAuthenticated = () => {
  return getUserData() !== null;
};
